export class BrowserUtil {

	/**
	 * Clears/removes all browser selection/highlighting. Intended use is to clear unwanted selection due to double clicking.
	 */
	static clearSelection() {
		window.getSelection?.().removeAllRanges?.();
	}
}
